import React from "react";
import { imageLoader } from "../../../../utils/imageLoader";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  addOpenLot,
  setActiveOnglet,
  fetchSingleLot,
} from "../../../../redux/actions/immobilierActions";

const DeepSearchResults = ({
  deepSearchResults,
  openNewtab = true,
  setDisplayedLot,
}) => {
  const isDisplayed = useSelector(
    (state) => state.displayHonorairesReducer.isDisplayed
  );
  const dispatch = useDispatch();
  const handleLotClick = async (documentId) => {
    dispatch(addOpenLot(documentId));
    dispatch(fetchSingleLot(documentId));
    dispatch(setActiveOnglet(`lot-${documentId}`));
  };
  return (
    <div>
      <div className="table ">
        {/* Header */}
        <div className="table-lot-header pink text-center ">
          <div className="table-cell">Lot</div>
          <div className="table-cell">Programme</div>
          <div className="table-cell">Dispositif</div>
          <div className="table-cell">Type</div>
          <div className="table-cell">Surface (m2)</div>
          <div className="table-cell">Étage</div>
          <div className="table-cell">Prix</div>
          <div className="table-cell">Prix/m²</div>
          <div className="table-cell">Loyer</div>
          <div className="table-cell">Honoraires</div>
        </div>

        {/* Rows */}
        {deepSearchResults?.length > 0 ? (
          deepSearchResults.map((lot) => (
            <div
              key={lot.documentId}
              className="table-lot-row cursor-pointer hoverborder"
              onClick={() => {
                openNewtab
                  ? handleLotClick(lot?.documentId)
                  : setDisplayedLot(lot);
              }}
            >
              {/* Lot */}
              <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="plan-image position-relative">
                    <span
                      className={
                        lot?.disponibility?.disponibilite === "Disponible"
                          ? "position-absolute top-0 start-0 bg-green py-1 px-2 radius5 fs11 "
                          : "position-absolute top-0 start-0 bg-yellow py-1 px-2 radius5 fs11 "
                      }
                    >
                      {lot?.disponibility?.disponibilite === "Disponible"
                        ? "Disponible"
                        : "Optionné"}
                    </span>
                    <img
                      src={imageLoader(lot?.images[1]?.image[0]?.url)}
                      alt=""
                      className="radius5"
                    />
                  </div>
                  <div>
                    <p
                      className="mb-0 fs16 darkGrey semibold"
                      title={lot.reference}
                    >
                      {lot.reference}
                    </p>
                    {/* <p className="text-muted mb-0 fs11 darkGrey regular">
                      {lot.availability === "available"
                        ? "Disponible"
                        : "Optionné"}
                    </p> */}
                  </div>
                </div>
              </div>

              {/* Programme */}
              <div className="table-cell p-0">
                <div className="d-flex align-items-center gap-2">
                  <div className="program-image">
                    <img
                      src={imageLoader(lot.images[1]?.image[0]?.url)}
                      alt=""
                    />
                  </div>
                  <div className="d-flex flex-column text-start">
                    <div>
                      <p
                        className="mb-0 fs16 darkGrey semibold text-wrap "
                        title={lot.programme_parent.name}
                      >
                        {lot.programme_parent.name}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent.address}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 fs11 darkGrey semibold">
                        {lot.programme_parent.municipality}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {lot.programme_parent.delivery_date
                          ? moment(lot.programme_parent.delivery_date).format(
                              "YYYY"
                            ) +
                            " T-" +
                            moment(lot.programme_parent.delivery_date).quarter()
                          : "NC"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Dispositif */}
              <div className="table-cell">
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex flex-column justify-content-between gap6">
                    {lot.project_types?.map((badge, index) => (
                      <span
                        key={badge.documentId}
                        className="fs11 bg-green radius5 py-1 px-2 text-white"
                        title={badge.label}
                      >
                        {badge.label}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Type */}
              <div className="table-cell text-capitalize">{lot.typology}</div>

              {/* Surface */}
              <div className="table-cell">{lot.surface}</div>

              {/* Étage */}
              <div className="table-cell">
                {lot.floor === null
                  ? "NC"
                  : lot.floor == 0
                  ? "RDC"
                  : lot.floor == 1
                  ? "1er"
                  : lot.floor + "ème"}
              </div>

              {/* Prix */}
              <div className="table-cell">
                <div className="text-center">
                  <small className="text-muted fs11 regular darkGrey">
                    {"TVA " + lot.price_vat_rate + "%"}
                  </small>
                  <p className="mb-0 fs16 semibold darkGrey">
                    {Intl.NumberFormat("fr-FR").format(lot.price_total) + " €"}
                  </p>
                </div>
              </div>

              {/* Prix/m² */}
              <div className="table-cell">
                {(lot.price_total / lot.surface).toFixed(1) + " €"}
              </div>

              {/* Loyer */}
              <div className="table-cell">{lot.rent + " €"}</div>

              {/* Honoraires */}
              <div className="table-cell">
                {isDisplayed
                  ? lot.commission
                    ? lot.commission.match(/\d+\.\d+/) + "%"
                    : "NC"
                  : "***"}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">Pas de lots</div>
        )}
      </div>
    </div>
  );
};

export default DeepSearchResults;
